import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/search.scss';
// import 'unfetch/polyfill';
import Pagination from 'tui-pagination';
import {
    addThirdPartyLoad, Http,
    initFreshChatScript,
    onInstantQuoteFreshChatClick,
    onPriceMatchFreshChatClick
} from "../js/src/utils";
import {
    addToCartBtn,
    addToCartUtil,
    cartStoreSubscribe,
    confirmMoqQuantity,
    getComponentsData,
    setComponentsList,
    manageBuyBtn
} from "../js/src/cart-utils";
import {getQuoteFormInit, scrollToQuoteForm} from "../js/src/get-quote-form";
import {initWarehouseAvailability} from "../js/src/warehouse-availability";


/*
 * First thing in the module, before the header, chat, cart and analytics wiring.
 *
 * Two reasons it is not inside addThirdPartyLoad() like the rest: that queue is
 * only flushed on the first scroll/mousedown/mousemove/touchstart/keydown, so a
 * visitor who lands on an empty result and does not touch anything would never
 * see the search start; and the live sources are the long pole, so every
 * millisecond earlier is a millisecond off the visitor's wait. Running it above
 * everything else also means a failure in any of that setup cannot stop it.
 *
 * No-ops unless the template rendered #warehouse-availability-box, which only
 * happens when /search came back empty for something shaped like a part number.
 */
initWarehouseAvailability();

initMainHeader();
global.scrollToQuoteForm = (e) => {
    e.preventDefault();
    scrollToQuoteForm();
};
initFreshChatScript();

const MIN_QTY_LENGTH = 3;
const PER_PAGE = 20;

// Rows are built as HTML strings — escape every value that comes from the API.
const escapeHtml = (value) => {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
};
const escapeAttr = (value) => escapeHtml(value).replace(/"/g, '&quot;');

/**
 * Mirrors components/add-quote-button.twig for dynamically loaded rows.
 *
 * @param conf
 * @param type
 * @returns {string}
 */
const addToQuoteBtn = (conf, type = 'component') => `
    <button type="button" class="btn-quote add-to-quote-btn"
        data-id="${escapeAttr(conf.id)}"
        data-partnum="${escapeAttr(conf.partnum)}"
        data-name="${escapeAttr(conf.productName)}"
        data-manufacturer="${escapeAttr(conf.manufacturer || '')}"
        data-condition="${escapeAttr(conf.condition || '')}"
        data-type="${type}"
        data-moq="${escapeAttr(conf.moq || '')}"
        onclick="addToQuote(this)">
        <img src="/build/assets/svg/icons/quote.svg" height="30" width="25" alt="Quote icon"/>
        Add to Quote
    </button>
`;
const total = global.itcSearchTotal || {
    totalHits: 0,
    resultCount: 0,
    serverTotal: 0,
    serversCount: 0,
}
// const phrase = encodeURIComponent(document.querySelector('input[name="phrase"]').value);
// const filterLoader = document.getElementById('filter-loader');
//
// const productObj = {
//     id: 1,
//     title: 'Components',
//     loadHref: 'getSearch',
//     parentBox: document.getElementById('product-list-box'),
//     showMoreBtn: document.getElementById('show-more-button'),
//     paginationBox: document.getElementById('pagination-box'),
//     pagination: null,
//     currentPage: 1,
//     perPage: PER_PAGE,
//     maxPage: total.resultCount,
//     total: total.totalHits,
//     loadCreator: getNewProduct,
// };
// const serverObj = {
//     id: 0,
//     title: 'Servers',
//     loadHref: 'searchServers',
//     parentBox: document.getElementById('server-list-box'),
//     showMoreBtn: document.getElementById('show-more-server'),
//     paginationBox: document.getElementById('pagination-box-server'),
//     pagination: null,
//     currentPage: 1,
//     perPage: PER_PAGE,
//     maxPage: total.serversCount,
//     total: total.serverTotal,
//     loadCreator: getNewServer,
// };
// let componentsInCart = {};
//
//
// init(productObj);
// init(serverObj);
// const paginators = [serverObj, productObj];

let componentsInCart = {};
let paginators = [];
const phrase = encodeURIComponent(document.querySelector('input[name="phrase"]').value);
const filterLoader = document.getElementById('filter-loader');
const updateButtons = (data) => {
    componentsInCart = data;

    Object.keys(data).forEach(serverId => {
        manageBuyBtn(serverId, false);
    })
}
cartStoreSubscribe(updateButtons);
addThirdPartyLoad(() => {
    initAll();
    getQuoteFormInit();
});

function initAll() {
    const productObj = {
        id: 1,
        title: 'Components',
        loadHref: 'getSearch',
        parentBox: document.getElementById('product-list-box'),
        showMoreBtn: document.getElementById('show-more-button'),
        paginationBox: document.getElementById('pagination-box'),
        pagination: null,
        currentPage: 1,
        perPage: PER_PAGE,
        maxPage: total.resultCount,
        total: total.totalHits,
        loadCreator: getNewProduct,
    };
    const serverObj = {
        id: 0,
        title: 'Servers',
        loadHref: 'searchServers',
        parentBox: document.getElementById('server-list-box'),
        showMoreBtn: document.getElementById('show-more-server'),
        paginationBox: document.getElementById('pagination-box-server'),
        pagination: null,
        currentPage: 1,
        perPage: PER_PAGE,
        maxPage: total.serversCount,
        total: total.serverTotal,
        loadCreator: getNewServer,
    };

    initBlock(productObj);
    initBlock(serverObj);
    // paginators is indexed by the paginationId passed to showMore(el, id),
    // which equals each object's .id — keep this array ordered by id.
    paginators = [serverObj, productObj];
}

function initBlock(targetObj) {
    const parentBox = targetObj.parentBox;

    if (!parentBox) {
        return
    }

    if (!targetObj.paginationBox) {
        return
    }

    const changeHandler = 'changePage' + targetObj.id;
    global[changeHandler] = changePage.bind(null, targetObj)

    targetObj.pagination = new Pagination(targetObj.paginationBox, {
        totalItems: targetObj.total,
        itemsPerPage: targetObj.perPage,
        visiblePages: window.innerWidth > 991 ? 10 : (window.innerWidth < 460 ? 3 : 5),
        centerAlign: true,
        usageStatistics: false,

        template: {
            page: '<li class="page-item"><button class="page-link" onclick="' + changeHandler + '({{page}}, '+ targetObj.id +')" data-paginator="'+ targetObj.id +'" rel="nofollow noindex">{{page}}</button></li>',
            currentPage: '<li class="page-item"><span class="page-link active">{{page}}</span></li>',
            moveButton: '<li class="page-item"><button class="page-link {{type}}" onclick="' + changeHandler + '(\'{{type}}\', '+ targetObj.id +')" data-paginator="'+ targetObj.id +'" rel="nofollow noindex">{{type}}</button></li>',
            disabledMoveButton: '<li class="page-item"><span class="page-link disabled {{type}}">{{type}}</span></li>',
            moreButton: '<li class="page-item"><span class="page-link {{type}}">...</span></li>'
        }
    });

    targetObj.currentPage = targetObj.pagination.getCurrentPage();

    // cartStoreSubscribe(data => {
    //     componentsInCart = data;
    //
    //     Object.keys(data).forEach(serverId => {
    //         manageBuyBtn(serverId, false);
    //     })
    // });
}


/**
 *
 * @param paginator
 * @param newPage
 * @param paginationId
 */
function changePage (paginator, newPage, paginationId) {
    window.scrollTo({
        top: paginator.parentBox.getBoundingClientRect().top + window.pageYOffset,
        behavior: "smooth",
    });

    const _page = {
        first: 1,
        last: paginator.maxPage,
        prev: paginator.currentPage - 1,
        next: paginator.currentPage + 1
    }[newPage];

    paginator.currentPage = typeof _page !== 'undefined' ? _page : newPage

    loadNewItems(paginator, paginator.currentPage);
}

/**
 *
 * @param el
 * @param paginationId
 */
global.showMore = (el, paginationId) => {
    const paginator = paginators[paginationId];

    window.scrollTo({
        top: el.getBoundingClientRect().top + window.pageYOffset - 100,
        behavior: "smooth",
    });

    loadNewItems(paginator, ++paginator.currentPage, true);
}

/**
 *
 * @param paginator
 * @param page
 * @param isShowMore
 */
function loadNewItems(paginator, page, isShowMore = false) {

    paginator.pagination.movePageTo(page);
    paginator.showMoreBtn.disabled = page === paginator.maxPage;

    filterStart();

    // &size=${perPage}
    Http.getJson(`/${ paginator.loadHref }?s=${ phrase }&from=${ page }`)
        // .then(r => r.json())
        .then(res => {

            if (!res) {
                return
            }

            const hits = {
                0: res.servers && res.servers.hits,
                1: res.components && res.components.hits,
            }[paginator.id];

            if (!hits || !hits.length) {
                return
            }

            if (isShowMore) {
                addNewItems(paginator, hits)
            } else {
                replaceNewItems(paginator, hits)
            }

            if (paginator.id === 1) {
                setComponentsList(hits, !isShowMore);
                setTimeout(() => {
                    Object.keys(componentsInCart).forEach(sid => manageBuyBtn(sid, false))
                }, 200)
            }
        })
        .finally(filterEnd)
}

/**
 *
 * @param paginator
 * @param list
 */
function addNewItems(paginator, list) {
    const fr = document.createDocumentFragment();
    const newCls = 'new-item';

    list.forEach(item => {
        const temp = document.createElement('div');

        temp.innerHTML = rowItem(paginator.loadCreator(item), newCls);
        fr.appendChild(temp)
    })

    paginator.parentBox.appendChild(fr);

    setTimeout(() => {
        paginator.parentBox.querySelectorAll('.new-item').forEach(item => {
            item.classList.remove(newCls);
        })
    }, 20)
}

/**
 *
 * @param paginator
 * @param list
 */
function replaceNewItems(paginator, list) {
    const items = list.map(item => rowItem(paginator.loadCreator(item))).join('');

    paginator.parentBox.innerHTML = `<h2 class="group-title">${paginator.title}</h2>${items}`
}

/**
 *
 * @param html
 * @param cls
 * @returns {string}
 */
function rowItem(html, cls = '') {
    return `<div class="item-row${cls ? ' ' + cls : ''}">${html}</div>`
}

/**
 *
 * @param conf
 * @param cls
 * @returns {string}
 */
/**
 * MOQ column of a result: only when the order quantity is not the standard 1.
 * Same markup as the server-rendered first page (search.twig).
 *
 * @param conf
 * @returns {string}
 */
function moqField(conf) {
    if (!conf.moq || conf.moq <= 1) {
        return '';
    }

    const label = conf.fixedQty ? 'Fixed order quantity:' : 'Minimum order quantity:';

    return `<p class="moq-field"><b>${ label }</b> <span class="moq-value">${ conf.moq }</span></p>`;
}

function getNewProduct(conf, cls = '') {
    const defImg = window.__itc_def_img;
    return `
        <div class="item-bottom items-list">
            <div class="server-image">
                <a href="/product/${conf.id}" title="${conf.productName} Image" target="_blank">
                    <img class="img-thumbnail" src="${conf.productImage || defImg}" alt="${conf.productName}" onerror="this.classList.add('b-error')" width="400" height="300" loading="lazy">
                </a>
            </div>
            <div class="data-box">
                <a href="/product/${conf.id}" class="conf-title prod-desc"
                   title="Show ${conf.productName} Details" target="_blank">
                    ${conf.productName}
                </a>
                <div class="data-row">
                    <div class="description-box">
                        <p><b>Part number:</b> ${conf.partnum}</p>
                        <p><b>Condition:</b> ${conf.condition}</p>
                        ${conf.manufacturer ? '<p><b>Manufacturer:</b> ' + conf.manufacturer + '</p>' : ''}
                        ${moqField(conf)}
                        ${conf.quantity != 0 ?
                            `<p><b>Availability:</b> <b class="in-stock">In Stock</b></p>
                            <div class="stock">
                                <span class="dg-box">
                                    <b>Qty in stock:</b>
                                    ${getDg(conf.quantity)}
                                </span>
                                <i class="date">as of ${conf.dateChanged}</i>
                            </div>
                            <p><b>Ships from:</b> Los Angeles Warehouse </p>`
                        :
                            `<p><b>Availability:</b> ETA 3-4 days</p>
                            <p><b>Qty in stock:</b> Request Pricing</p>`
                        }
                    </div>

                    <div class="price-box">
                        <p class="price-value">
                            ${ conf.price != 0 && conf.quantity > 0 ? conf.priceString : ''}
                        </p>

                        <div class="btn-box">
                            ${conf.price != 0 && conf.quantity > 0 && conf.qtyAvailable !== false ?
                                `${ addToCartBtn(conf.id, '1') }${ addToQuoteBtn(conf) }<button class="btn-quote" onclick="priceMatch(event, this)">${ quoteSvg }Request Price Match</button>`
                                : `${ addToQuoteBtn(conf) }<button class="btn-quote" onclick="instantQuote(event, this)">${ quoteSvg } Instant Quote</button>`}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

function getNewServer(conf) {
    const defImg = window.__itc_def_img;

    return `
        <div class="item-bottom items-list">
            <div class="server-image">
                <a href="${ conf.landing_href ? conf.landing_href : (conf.conf_href ? conf.conf_href : conf.show_server_href) }" title="${conf.model_name} Image">
                    <img class="img-thumbnail" src="${conf.image || defImg}" alt="${conf.model_name}" width="400" height="300" loading="lazy">
                </a>
            </div>
            <div class="data-box">
                <a href="${ conf.landing_href ? conf.landing_href : (conf.conf_href ? conf.conf_href : conf.show_server_href) }" class="conf-title prod-desc"
                   title="Show ${ conf.model_name }} Details">
                    ${ conf.model_name }
                </a>
                <div class="data-col">
                    <div class="description-box">
                        ${conf.tags ? conf.tags : '' }
                        ${conf.condition && conf.warranty ?
                        `<p><b>Condition</b> - ${conf.condition }</p><p><b>Warranty</b> - ${conf.warranty }</p>`
                        : ''}
                        ${conf.description ? conf.description : '' }
                    </div>

                    <div class="price-box">
                        <div class="btn-row">
                            ${conf.conf_href ?
                            `<a class="btn buy-btn btn-lg btn-primary" href="${ conf.conf_href }" target="_blank">
                                Configure Server
                            </a>` : '' }

                            ${conf.show_server_href ?
                            `<a class="btn buy-btn btn-lg btn-success" href="${ conf.show_server_href }" title="Shop Now">Shop Now</a>` : '' }

                            ${conf.landing_href ?
                            `<a class="btn-quote" href="${ conf.landing_href }" target="_blank">${detailsSvg}Details</a>` : '' }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

function getDg(dg) {
    try {
        return String(dg).padStart(MIN_QTY_LENGTH, '0').split('').map(d => `<p class="dg">${d}</p>`).join('')
    } catch (e) {
        return `<p class="dg">${dg}</p>`
    }
}

/**
 *
 */
function filterStart() {
    filterLoader.classList.add('show')
}

/**
 *
 */
function filterEnd() {
    filterLoader.classList.remove('show')
}

const detailsSvg = '<img src="/build/assets/svg/icons/file-text2.svg" height="30" width="25"/><div class="loader"></div>';

const quoteSvg = '<img src="/build/assets/svg/icons/quote.svg" height="30" width="25"/><div class="loader"><progress class="mat-progress s18"></progress></div>';

const addToCart = async (componentId, type, btn) => {
    const component = getComponentsData().find(c => c.id == componentId);

    if (!component) {
        return
    }

    const eParams = {
        id: component.id,
        item_id: component.partnum,
        item_name: component.productName,
        item_category: "Components",
        item_brand: component.manufacturer,
        price: component.price
    }

    // MOQ: the result adds exactly the minimum (server-side rule, see QuantityRule);
    // a fixed-quantity item gets its MOQ on the server whatever is sent.
    const qty = component.minQty || 1;
    const confirmed = await confirmMoqQuantity({moq: component.moq, qty, fixed: component.fixedQty});

    if (!confirmed) {
        return
    }

    addToCartUtil(componentId, type, btn, eParams, qty)
};

/**
 *
 * @param id
 */
global.scrollToServer = (id) => {
    const box = document.getElementById(id);

    window.scrollTo({top: box.offsetTop + 20, behavior: 'smooth'});
};
global.priceMatch = onPriceMatchFreshChatClick;
global.instantQuote = onInstantQuoteFreshChatClick;
global.addToCart = addToCart;
